import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import "../App.css";
import { useDispatch } from "react-redux";
import Logo from "../assets/images/bayin.png";
import { forgotOtp, sendOtp, verifyOtp } from "../redux/actions/authAction";
import { toast } from "react-toastify";
const initialState = {
    otp: "",
    email: "",
    errors: {},
    loading:false,
}

const OtpVerification = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [iState, updateState] = useState(initialState)
    const { otp, email, errors ,loading} = iState;
    const ID = JSON.parse(localStorage.getItem("emailId"));
    const handleChange = (e) => {
        const { name, value } = e.target;
    
        updateState({
            ...iState,
            [name]: value,
        });
    };


    let handleValidation = () => {
        let error = {};
        let formIsValid = true;

        if (!otp.trim()) {
            error.otpError = "*OTP can't be empty";
            formIsValid = false;
        }
        updateState({
            ...iState,
            errors: error,
        });
        return formIsValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        updateState({...iState, loading:true})
             const data = {  email:ID}
            dispatch(forgotOtp(data))
                .then((res) => {

                    if (res.status == 200) {
                        toast.success(res.message, {
                            position: toast.POSITION.TOP_RIGHT,
                        });

                        updateState({ ...iState,loading:false });
                    }
                })
                .catch((err) => {

                    // toast.error(res.message, {
                    //     position: toast.POSITION.TOP_RIGHT,
                    // });
                    updateState({ ...iState,loading:false });
                    const message =
                        err?.response?.data
                            ? err?.response?.data?.message
                            : "Something went wrong.";
                    toast.error(message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                });

 
    };

    
    const handleVerify = (e) => {
        e.preventDefault();
        let formIsValid = handleValidation();
        if (formIsValid) {
            updateState({...iState,loading:true})
            const data = { otp:parseInt(otp),email:ID}
            dispatch(verifyOtp(data))
                .then((res) => {

                    if (res.status == 200) {
                        toast.success(res.message, {
                            position: toast.POSITION.TOP_RIGHT,
                        });

                        navigate("/change-password");
                        updateState({ ...iState,loading:false });
                    } else {
                        toast.error("Entered otp is Incorrect", {
                            position: toast.POSITION.TOP_RIGHT,
                        })
                        updateState({ ...iState,loading:false });
                    }
                })
                .catch((err) => {
                    
                  
                    const message =
                        err?.response?.data
                            ? err?.response?.data?.message
                            : "Something went wrong.";
                    toast.error(message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                });

        }
    };


    return (
        <div>
            <div class="LoginArea" >

                <div class="LoginBox">
                <figure>
                    <img src={Logo} />
                </figure>

                    <h3>OTP Verification</h3>
                    <h4>Please enter 6 digit OTP Verification code  received on your email address.</h4>
                    <div class="form-group">
                        <input type="text" placeholder="Enter OTP " className="form-control formControl" name="otp" value={otp} onChange={handleChange} />
                        <button className="Reset" onClick={handleSubmit} disabled={loading}>Resend</button>
                        <span style={{ color: "red", fontSize: "12px" }}>{errors.otpError}</span>
                    </div>
                    <button className="Button" onClick={handleVerify} disabled={loading}>Submit</button>
                </div>
            </div>
        </div>
    );
}
export default OtpVerification